import { useEffect, useState } from "react";

type windowSize = {
  width: number;
  height: number;
};
export type TWindowSize = windowSize;
const useWindowSize = (): any => {
  const [windowSize, setWindowSize] = useState<windowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [screen, setScreen] = useState<string>("xl");
  const returnScreens = (width: number) => {
    if (width >= 320 && width <= 480) {
      //   320px — 480px: Mobile devices
      return "sm";
    } else if (width >= 481 && width <= 768) {
      // 481px — 768px: iPads, Tablets
      return "md";
    } else if (width >= 769 && width <= 1024) {
      // 769px — 1024px: Small screens, laptops
      return "lg";
    } else if (width >= 1025 && width <= 1200) {
      // 1025px — 1200px: Desktops, large screens
      return "xl";
    } else {
      // 1201px and more —  Extra large screens, TV
      return "xxl";
    }
  };

  useEffect(() => {
    const handleResize = (): void => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      setScreen(returnScreens(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { windowSize, screen };
};

export default useWindowSize;
